import * as React from "react";
import { useNavigate } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { postLogin } from "../Utils/api-service";
import { Paper } from "@mui/material";
import Deposits from "../_Components/MainLayoutComponent/Deposits";
import Orders from "../_Components/MainLayoutComponent/Orders";
import VendorChart from "../_Components/VendorLayout/VendorChart";
import Boxes from "../_Components/Common/Boxes";
import VendorList from "../_Components/VendorLayout/VendorList";

export default function Vendors() {
  const navigate = useNavigate();

  return (
    <Grid container spacing={3}>
      {/* <Grid item xs={12} md={4} lg={4}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            height: 240,
          }}
        >
          <VendorChart />
        </Paper>
      </Grid> */}
      {/* Recent Deposits */}
      {/* <Grid item xs={12} md={4} lg={4}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            height: 240,
          }}
        >
          <Boxes title={"Total Vendors"} totalNumber={51} asOndate={true} />
        </Paper>
      </Grid> */}
      {/* <Grid item xs={12} md={4} lg={4}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            height: 119,
            marginBottom: 0.5,
            border: "none",
          }}
        >
          <Boxes title={"Active Accounts"} totalNumber={50} asOndate={true} />
        </Paper>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            height: 120,
          }}
        >
          <Boxes title={"InActive Accounts"} totalNumber={0} asOndate={true} />
        </Paper>
      </Grid> */}
      {/* Recent Orders */}
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
          <VendorList />
        </Paper>
      </Grid>
    </Grid>
  );
}
